import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../..'
import { StepNumber } from '@/src/ct-design/lib/Stepper'

interface AnimationState {
    visibleStepIndex: number
    stepperPosition: number
}

const initialState: AnimationState = {
    visibleStepIndex: 1,
    stepperPosition: 1
}

const animationSlice = createSlice({
    name: 'animation',
    initialState,
    reducers: {
        setVisibleStep: (state, action: PayloadAction<number>) => {
            state.visibleStepIndex = action.payload
        },
        setStepperPosition: (state, action: PayloadAction<number>) => {
            state.stepperPosition = action.payload
        }
    }
})

export const { setVisibleStep, setStepperPosition } = animationSlice.actions

export const getVisibleStepIndex = (state: RootState) =>
    state.animation.visibleStepIndex
export const getStepperPosition = (state: RootState) =>
    state.animation.stepperPosition

export default animationSlice.reducer
